import dayjs from 'dayjs';
import * as React from 'react';
import { Countdown } from '~common/Countdown';
import { DateTimeFormat } from '~config/constants';
import {
  DHDistribution,
  DHDistributionStatus,
} from '~features/diamondHands/useDHDistribution';
import { fDate } from '~features/diamondHands/utils';
import { Alert } from '~features/ui';

export function DHStatusCountdown({
  distribution,
}: {
  distribution: DHDistribution;
}) {
  const { status } = distribution;

  if (status === DHDistributionStatus.NoDate) {
    return (
      <div>
        <Alert>
          This distribution has not been scheduled yet. Please check back later.
        </Alert>
      </div>
    );
  }

  if (status === DHDistributionStatus.PreRegistration) {
    return (
      <div>
        <Alert>
          <p>
            This distribution will open for registration on{' '}
            {dayjs
              .unix(distribution.registrationStart)
              .format(DateTimeFormat.full)}
          </p>
          <p>
            Opens in{' '}
            <b>
              <Countdown date={distribution.registrationStart} />
            </b>
          </p>
        </Alert>
      </div>
    );
  }

  if (status === DHDistributionStatus.Registration) {
    return (
      <div>
        <Alert>
          <p>This distribution is open for registration.</p>
          <p>
            Closes in{' '}
            <b>
              <Countdown date={distribution.start} />
            </b>
          </p>
        </Alert>
      </div>
    );
  }

  if (status === DHDistributionStatus.Claiming) {
    return (
      <div>
        <Alert>
          Rewards will be airdropped on <b>May 25, 18:00 UTC</b>.
        </Alert>

        {/*<p>*/}
        {/*  Claiming time: <b>{fDate(distribution.start)}</b> –{' '}*/}
        {/*  <b>{fDate(distribution.end)}</b>*/}
        {/*</p>*/}
        {/*<p>*/}
        {/*  Claiming ends in{' '}*/}
        {/*  <b>*/}
        {/*    <Countdown date={distribution.end} />*/}
        {/*  </b>*/}
        {/*</p>*/}
      </div>
    );
  }

  if (status === DHDistributionStatus.Finished) {
    return (
      <div>
        <Alert>This distribution has ended.</Alert>
        {/*<p>*/}
        {/*  Next distribution:*/}
        {/*  {distribution.nextRegistrationStart > 0*/}
        {/*    ? fDate(distribution.nextRegistrationStart)*/}
        {/*    : ` to be announced.`}*/}
        {/*</p>*/}
        {distribution.nextRegistrationStart > 0 && (
          <Countdown date={distribution.start} />
        )}
      </div>
    );
  }

  return <div>UnknownStatus {status}</div>;
}
